import { activeRequests, allowedRequestUrl } from '@/modules/core/api/store/api.state';
import { AxiosRequestController } from '@/modules/core/app/models/AxiosRequestController';

export function getActiveRequests(): AxiosRequestController[] {
  return activeRequests.value;
}

export function getAllowedRequestUrl(): string | undefined {
  return allowedRequestUrl.value;
}
